export const translations = {
  tr: {
    nav: {
      product: "Ürün",
      lab: "Lab Raporu",
      howto: "Nasıl Kullanılır",
      faq: "SSS",
      contact: "İletişim",
      cta: "Sipariş Ver",
    },
    hero: {
      eyebrow: "PAKLA · Meyve & Sebze Yıkama Solüsyonu",
      lines: ["Doğadan", "Sofraya", "Saf Temizlik."],
      body: "Sebze ve meyvelerinizdeki pestisit kalıntılarını, bakteri ve toprak izlerini bitkisel kökenli formülü ile arındırır ve sofranıza sadece doğallığı bırakır.",
      primary: "Nasıl Çalışır",
      secondary: "İletişime Geç",
      scroll: "Kaydırın",
    },
    marquee: "DOĞAL   SAF   TEMİZ   GÜVENLİ   BİTKİSEL KÖKENLİ   %100 ORGANİK",
    manifesto: {
      eyebrow: "— Manifesto",
      title: "Görünmeyene karşı,\ngörünür bir güç.",
      chapters: [
        {
          number: "01",
          title: "Pestisit Arındırır",
          text: "Pestisit, gübre ve endüstriyel kimyasal kalıntılarının sebze ve meyvelerinizden arınmasına yardımcı olur. Kabuğun üstündeki tehlikeye odaklanır.",
        },
        {
          number: "02",
          title: "Bakteri ve Kirleri Temizler",
          text: "Toprak, virüs, bakteri ve kirleticileri etkin şekilde uzaklaştırır. Salatanız pazarda kaldığı yerden değil, doğadan kalktığı gibi başlar.",
        },
        {
          number: "03",
          title: "%100 Bitkisel & Güvenli",
          text: "Doğal içerikleri sayesinde sevdikleriniz için güvenlidir. Kalıntı bırakmaz, sofranıza dokunmaz, doğaya zarar vermez.",
        },
      ],
    },
    howto: {
      eyebrow: "— Kullanım Talimatı",
      title: "Üç adımda,\nbir dakikada.",
      steps: [
        {
          n: "1",
          title: "Suya Ekleyin",
          text: "1 litre suya 2 kapak (≈ 20 ml) PAKLA ekleyin. Karışım anında berrak bir doğallık kazanır.",
          meta: "≈ 20 ml",
        },
        {
          n: "2",
          title: "Sebzeleri Yıkayın",
          text: "Sebze ve meyvelerinizi karışıma daldırın. 1 dakika boyunca bekletin, hafifçe çalkalayın.",
          meta: "1 dakika",
        },
        {
          n: "3",
          title: "Durulayın",
          text: "Bol su ile durulayın. Artık yemeye, dilimlemeye ve paylaşmaya hazır.",
          meta: "bol su",
        },
      ],
    },
    products: {
      eyebrow: "— Ürünler",
      title: "İki hacim,\ntek ritüel.",
      body: "Ev mutfağı için 1 litre, profesyonel mutfaklar ve pazarlar için 5 litre. Her damlası, aynı doğa sözü.",
      one: { name: "PAKLA 1 LT", desc: "Ev kullanımı · 20 yıkama", cta: "Detay" },
      five: { name: "PAKLA 5 LT", desc: "Profesyonel mutfak · 100 yıkama", cta: "Detay" },
    },
    ingredients: {
      eyebrow: "— İçindekiler & Güvenlik",
      title: "Etikette ne yazıyorsa,\nşişede o var.",
      body: "PAKLA, bitkisel kökenli yüzey aktifleri ve gıdaya uygun yardımcı bileşenlerden oluşur. Boyar madde, koku yoğunlaştırıcı ve alkol içermez. Kalıntı bırakmaz.",
      pills: ["Bitkisel Kökenli", "Kalıntı Bırakmaz", "Aileniz İçin Güvenli", "Doğaya Duyarlı", "Gıda Güvenliği Uyumlu"],
    },
    testimonials: {
      eyebrow: "— Sofradan Sesler",
      title: "PAKLA ile\nkullananlar anlatıyor.",
      items: [
        { name: "Elif K.", role: "Anne · İstanbul", text: "Çocuklarımın kahvaltı tabağına artık bambaşka bir güvenle bakıyorum. Domateslerin tadı bile farklı." },
        { name: "Şef Murat", role: "Restoran Şefi · İzmir", text: "Profesyonel mutfağımda bir standart. 5 litrelik bidon, brigatanın günlük ritüeli." },
        { name: "Ayşe D.", role: "Diyetisyen · Ankara", text: "Danışanlarıma önerdiğim tek yıkama solüsyonu. Kalıntı bırakmaması en kritik faktör." },
      ],
    },
    faq: {
      eyebrow: "— SSS",
      title: "Cevap arayanlara,\ndürüst yanıtlar.",
      items: [
        { q: "PAKLA gıdaya güvenli mi?", a: "Evet. Bitkisel kökenli formülü sofraya uyumlu bileşenlerden oluşur ve durulama sonrası hiçbir kalıntı bırakmaz." },
        { q: "Hangi meyve ve sebzelerde kullanılabilir?", a: "Yumuşak yeşilliklerden sert kabuklu meyvelere kadar tüm taze ürünlerde güvenle kullanılır." },
        { q: "Kokusu var mı?", a: "PAKLA kokusuzdur. Doğal içerikleri sayesinde sebze ve meyvelerin gerçek aromasını değiştirmez." },
        { q: "1 litre ne kadar yeter?", a: "1 litre ile 20 yıkama, 5 litre ile 100 yıkama yapabilirsiniz. Her kullanımda yalnızca 20 ml (2 kapak) yeterlidir." },
        { q: "Toplu / restoran kullanımı için uygun mu?", a: "Evet. 5 litrelik bidonumuz profesyonel mutfaklar, kafeler ve pazarcılar için özel olarak sunulur." },
      ],
    },
    contact: {
      eyebrow: "— İletişim",
      title: "Bize yazın,\naynı sofradan konuşalım.",
      name: "Ad Soyad",
      email: "E-posta",
      phone: "Telefon",
      message: "Mesajınız",
      submit: "Mesajı Gönder",
      sending: "Gönderiliyor…",
      success: "Teşekkürler. Mesajınız iletildi.",
      error: "Bir sorun oluştu. Lütfen tekrar deneyin.",
    },
    footer: {
      tagline: "Doğadan gelen güç, sofranıza saf temizlik.",
      company: "ANATEK Kimya Sanayi ve Ticaret A.Ş.",
      address: "Şekerpınar Mh. Tepeören Cd. Tuzla Plus No:18/42 Çayırova, Kocaeli, Türkiye",
      phone: "+90 850 441 97 96",
      email: "info@pakla.net",
      rights: "Tüm hakları saklıdır.",
    },
  },
  en: {
    nav: {
      product: "Product",
      lab: "Lab Report",
      howto: "How to Use",
      faq: "FAQ",
      contact: "Contact",
      cta: "Order",
    },
    hero: {
      eyebrow: "PAKLA · Fruit & Vegetable Wash",
      lines: ["From Nature,", "To Your Table.", "Pure. Clean."],
      body: "PAKLA lifts pesticide residues, bacteria and soil traces from your produce with a plant-based formula. What remains on your plate is only nature.",
      primary: "How it works",
      secondary: "Contact us",
      scroll: "Scroll",
    },
    marquee: "NATURAL   PURE   CLEAN   SAFE   PLANT-BASED   100% ORGANIC",
    manifesto: {
      eyebrow: "— Manifesto",
      title: "Against the invisible,\na visible force.",
      chapters: [
        { number: "01", title: "Clears Pesticides", text: "Removes pesticide and industrial chemical residues from the surface of your fruits and vegetables. It doesn't touch what's inside — only what shouldn't be there." },
        { number: "02", title: "Washes Bacteria & Grime", text: "Soil, microbes and pollutants are lifted away. Your salad starts as if it just left the field, not the market shelf." },
        { number: "03", title: "100% Plant-based & Safe", text: "A natural formula that's safe for the people you love. No residue, no compromise on your table, no harm to the earth." },
      ],
    },
    howto: {
      eyebrow: "— How to Use",
      title: "Three steps,\none minute.",
      steps: [
        { n: "1", title: "Add to Water", text: "Add 2 caps (≈ 20 ml) of PAKLA to 1 litre of water. The mix instantly turns into a natural bath.", meta: "≈ 20 ml" },
        { n: "2", title: "Wash the Produce", text: "Immerse fruits and vegetables. Let them rest for one minute, swirl gently.", meta: "1 minute" },
        { n: "3", title: "Rinse", text: "Rinse with plenty of clean water. Ready to eat, slice and share.", meta: "rinse well" },
      ],
    },
    products: {
      eyebrow: "— Products",
      title: "Two sizes,\none ritual.",
      body: "1 litre for the home kitchen, 5 litres for professionals and markets. Every drop, the same promise of nature.",
      one: { name: "PAKLA 1 L", desc: "Home use · 20 washes", cta: "Details" },
      five: { name: "PAKLA 5 L", desc: "Professional kitchens · 100 washes", cta: "Details" },
    },
    ingredients: {
      eyebrow: "— Ingredients & Safety",
      title: "What the label says\nis what the bottle holds.",
      body: "PAKLA is built from plant-based surfactants and food-safe co-ingredients. No dyes, no perfumes, no alcohol. Leaves no residue.",
      pills: ["Plant-based", "Residue-free", "Family Safe", "Earth-friendly", "Food-safety Aligned"],
    },
    testimonials: {
      eyebrow: "— Voices at the Table",
      title: "The people who\nuse PAKLA.",
      items: [
        { name: "Elif K.", role: "Mother · Istanbul", text: "I look at my children's breakfast plate with a whole new kind of trust. Even the tomatoes taste different." },
        { name: "Chef Murat", role: "Restaurant Chef · Izmir", text: "It's a standard in my kitchen. The 5-litre jug is part of the daily ritual for the brigade." },
        { name: "Ayşe D.", role: "Dietitian · Ankara", text: "The only wash solution I recommend to my clients. Leaving no residue is the critical factor." },
      ],
    },
    faq: {
      eyebrow: "— FAQ",
      title: "Honest answers\nto real questions.",
      items: [
        { q: "Is PAKLA food safe?", a: "Yes. Its plant-based formula uses food-compatible ingredients and leaves no residue after rinsing." },
        { q: "Which produce can I use it on?", a: "From delicate leafy greens to firm-skinned fruits — safe across all fresh produce." },
        { q: "Does it have a scent?", a: "PAKLA is unscented. Its natural formula keeps the true aroma of your produce intact." },
        { q: "How far does 1 litre go?", a: "20 washes with 1 litre, 100 washes with 5 litres. Only 20 ml (2 caps) is needed per use." },
        { q: "Can I use it in a restaurant?", a: "Absolutely. The 5-litre format is designed for professional kitchens, cafés and markets." },
      ],
    },
    contact: {
      eyebrow: "— Contact",
      title: "Write to us,\nwe share the same table.",
      name: "Full name",
      email: "Email",
      phone: "Phone",
      message: "Your message",
      submit: "Send message",
      sending: "Sending…",
      success: "Thank you. Your message has been delivered.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "The power of nature, pure clean on your table.",
      company: "ANATEK Kimya Sanayi ve Ticaret A.Ş.",
      address: "Şekerpınar Mh. Tepeören Cd. Tuzla Plus No:18/42 Çayırova, Kocaeli, Türkiye",
      phone: "+90 850 441 97 96",
      email: "info@pakla.net",
      rights: "All rights reserved.",
    },
  },
  el: {
    nav: {
      product: "Προϊόν",
      lab: "Εργαστήριο",
      howto: "Χρήση",
      faq: "Συχνές",
      contact: "Επικοινωνία",
      cta: "Παραγγελία",
    },
    hero: {
      eyebrow: "PAKLA · Λύση Πλυσίματος Φρούτων & Λαχανικών",
      lines: ["Από τη Φύση,", "Στο Τραπέζι σας.", "Καθαρό. Αγνό."],
      body: "Το PAKLA απομακρύνει υπολείμματα φυτοφαρμάκων, βακτήρια και χώμα από τα φρούτα και λαχανικά σας με μια φυτική φόρμουλα. Στο πιάτο μένει μόνο η φύση.",
      primary: "Πώς λειτουργεί",
      secondary: "Επικοινωνήστε",
      scroll: "Κύλιση",
    },
    marquee: "ΦΥΣΙΚΟ   ΑΓΝΟ   ΚΑΘΑΡΟ   ΑΣΦΑΛΕΣ   ΦΥΤΙΚΗΣ ΠΡΟΕΛΕΥΣΗΣ   100% ΟΡΓΑΝΙΚΟ",
    manifesto: {
      eyebrow: "— Μανιφέστο",
      title: "Απέναντι στο αόρατο,\nμια ορατή δύναμη.",
      chapters: [
        { number: "01", title: "Καθαρίζει φυτοφάρμακα", text: "Αφαιρεί υπολείμματα φυτοφαρμάκων και βιομηχανικών χημικών από την επιφάνεια των φρούτων και λαχανικών σας." },
        { number: "02", title: "Απομακρύνει βακτήρια & ρύπους", text: "Χώμα, μικρόβια και ρύποι φεύγουν. Η σαλάτα σας ξεκινά όπως ακριβώς από το χωράφι." },
        { number: "03", title: "100% Φυτικό & Ασφαλές", text: "Φυσική φόρμουλα, ασφαλής για όσους αγαπάτε. Χωρίς κατάλοιπα, χωρίς συμβιβασμούς, χωρίς επιπτώσεις στη φύση." },
      ],
    },
    howto: {
      eyebrow: "— Οδηγίες Χρήσης",
      title: "Τρία βήματα,\nένα λεπτό.",
      steps: [
        { n: "1", title: "Ρίξτε στο νερό", text: "Προσθέστε 2 καπάκια (≈ 20 ml) PAKLA σε 1 λίτρο νερό.", meta: "≈ 20 ml" },
        { n: "2", title: "Πλύνετε", text: "Βυθίστε φρούτα και λαχανικά. Αφήστε τα για ένα λεπτό.", meta: "1 λεπτό" },
        { n: "3", title: "Ξεπλύνετε", text: "Ξεπλύνετε με άφθονο νερό. Έτοιμα για κατανάλωση.", meta: "άφθονο νερό" },
      ],
    },
    products: {
      eyebrow: "— Προϊόντα",
      title: "Δύο μεγέθη,\nμια τελετουργία.",
      body: "1 λίτρο για την οικιακή κουζίνα, 5 λίτρα για επαγγελματίες και αγορές.",
      one: { name: "PAKLA 1 L", desc: "Οικιακή χρήση · 20 πλυσίματα", cta: "Λεπτομέρειες" },
      five: { name: "PAKLA 5 L", desc: "Επαγγελματική κουζίνα · 100 πλυσίματα", cta: "Λεπτομέρειες" },
    },
    ingredients: {
      eyebrow: "— Συστατικά & Ασφάλεια",
      title: "Ό,τι λέει η ετικέτα,\nέχει το μπουκάλι.",
      body: "Το PAKLA είναι φτιαγμένο από φυτικά επιφανειοδραστικά και συστατικά κατάλληλα για τρόφιμα. Χωρίς χρωστικές, αρώματα, αλκοόλ.",
      pills: ["Φυτικής προέλευσης", "Χωρίς κατάλοιπα", "Ασφαλές για την οικογένεια", "Φιλικό προς τη φύση", "Συμβατό με ασφάλεια τροφίμων"],
    },
    testimonials: {
      eyebrow: "— Φωνές στο τραπέζι",
      title: "Αυτοί που χρησιμοποιούν\nPAKLA.",
      items: [
        { name: "Elif K.", role: "Μητέρα · Κωνσταντινούπολη", text: "Κοιτάζω το πρωινό των παιδιών μου με άλλη εμπιστοσύνη. Ακόμη κι οι ντομάτες έχουν άλλη γεύση." },
        { name: "Σεφ Μουράτ", role: "Σεφ Εστιατορίου · Σμύρνη", text: "Πρότυπο στην κουζίνα μου. Το 5λιτρο είναι μέρος της καθημερινής τελετουργίας." },
        { name: "Ayşe D.", role: "Διαιτολόγος · Άγκυρα", text: "Η μόνη λύση πλύσης που προτείνω στους πελάτες μου." },
      ],
    },
    faq: {
      eyebrow: "— Συχνές",
      title: "Ειλικρινείς απαντήσεις\nσε αληθινές ερωτήσεις.",
      items: [
        { q: "Είναι ασφαλές για τρόφιμα;", a: "Ναι. Η φυτική φόρμουλα δεν αφήνει κατάλοιπα μετά το ξέπλυμα." },
        { q: "Σε ποια προϊόντα;", a: "Από τρυφερά φυλλώδη μέχρι σκληρόφλουδα φρούτα — με ασφάλεια σε όλα τα φρέσκα προϊόντα." },
        { q: "Έχει άρωμα;", a: "Το PAKLA είναι άοσμο." },
        { q: "Πόσο διαρκεί το 1 λίτρο;", a: "20 πλυσίματα με 1 λίτρο, 100 με 5 λίτρα. Χρειάζονται μόνο 20 ml (2 καπάκια) ανά χρήση." },
        { q: "Επαγγελματική χρήση;", a: "Ναι — το 5λιτρο είναι σχεδιασμένο για επαγγελματικές κουζίνες." },
      ],
    },
    contact: {
      eyebrow: "— Επικοινωνία",
      title: "Γράψτε μας,\nμοιραζόμαστε το ίδιο τραπέζι.",
      name: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      message: "Το μήνυμά σας",
      submit: "Αποστολή",
      sending: "Αποστολή…",
      success: "Ευχαριστούμε. Το μήνυμα παραδόθηκε.",
      error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
    },
    footer: {
      tagline: "Η δύναμη της φύσης, καθαρή στο τραπέζι σας.",
      company: "ANATEK Kimya Sanayi ve Ticaret A.Ş.",
      address: "Şekerpınar Mh. Tepeören Cd. Tuzla Plus No:18/42 Çayırova, Κοτζαέλι, Τουρκία",
      phone: "+90 850 441 97 96",
      email: "info@pakla.net",
      rights: "Με επιφύλαξη κάθε νόμιμου δικαιώματος.",
    },
  },
};

export const LANGS = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "el", label: "EL" },
];
